import React from 'react';
import { ChefAvailabilityContext } from './ChefAvailabilityContext';

const ChefAvailabilityEvent = props => {
  const { availability } = props.event;
  return (
    <ChefAvailabilityContext.Consumer>
      {({ activeAvailability, deleteActive, clearActive }) => {
        const isActive =
          activeAvailability &&
          availability === activeAvailability.availability;
        return (
          <div className="chef-availability-event">
            {isActive ? (
              <p className="p">
                Delete?{' '}
                <span className="a--blue" onClick={deleteActive}>
                  Yes
                </span>{' '}
                <span className="a--blue" onClick={clearActive}>
                  No
                </span>
              </p>
            ) : (
              ''
            )}
          </div>
        );
      }}
    </ChefAvailabilityContext.Consumer>
  );
};

export default ChefAvailabilityEvent;



// WEBPACK FOOTER //
// ./src/components/chef/ChefAvailabilityEvent.js